import script from "./PageSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageSearch.vue?vue&type=script&setup=true&lang=ts"

import "./PageSearch.vue?vue&type=style&index=0&id=2edd932a&scoped=true&lang=less"

import exportComponent from "E:\\twl\\workspace\\auxiliary-ts-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2edd932a"]])

export default __exports__